import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { useTranslation } from "@coworker/locales";
import Support from "./Support";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";

interface SupportModalProps {
  modalVisibility: boolean;
  onModalChange: (visibility: boolean) => void;
  storeId?: string;
}

export const SupportModal = ({
  modalVisibility,
  onModalChange,
  storeId,
}: SupportModalProps) => {
  const { t } = useTranslation();
  return (
    <FixaModal
      visible={modalVisibility}
      handleCloseBtn={() => {
        onModalChange(!modalVisibility);
      }}
    >
      <FixaSheets
        labelledById="support-modal-title-header"
        header={
          <FixaModalHeader
            id="support-modal-title-header"
            ariaCloseTxt={t("closeActionString")}
            title={t("superUsersString")}
          />
        }
        footer={
          <FixaModalFooter>
            <></>
          </FixaModalFooter>
        }
      >
        <Support storeId={storeId} />
      </FixaSheets>
    </FixaModal>
  );
};
